<template>
  <div>
    <CRow class="w-100">
      <CCol md="12" lg="12" sm="12" xs="12">
        <ReportsVue v-if="page == 'home'" @changePage="changePage" @setView="setView" />
        <PurchaseVue class="pt-1" v-if="page == 'purchase_reports'" @mtdBack="mtdBack" />
        <SaleVue class="pt-1" v-if="page == 'sale_reports'" @mtdBack="mtdBack" />
        <citasVue class="pt-1" v-if="page == 'citas'" @mtdBack="mtdBack" />
        <AsistenciaReportVue class="pt-1" v-if="page == 'asistencia_reports_demo'" @mtdBack="mtdBack" />
        <AsistenciaReportKatalynasVue class="pt-1" v-if="page == 'asistencia_reports_katalynas'" @mtdBack="mtdBack" />
        <EncargadoReportVueKatalynas class="pt-1" v-if="page == 'encargado_reports' && $store.getters.get_company.id == 10" @mtdBack="mtdBack" />
        <EncargadoReportVue class="pt-1" v-else-if="page == 'encargado_reports'" @mtdBack="mtdBack" />
        <CajaReportVue class="pt-1" v-if="page == 'box_reports' && $store.getters.get_rol.id == 4 " @mtdBack="mtdBack" />
        <ClientReportVue class="pt-1" v-if="page == 'clients_reports'"  @mtdBack="mtdBack" />
        <ReportDocument class="pt-1" v-if="page == 'documents_reports'"  @mtdBack="mtdBack" />
        <ReportUnregisteredServicesVue class="pt-1" v-if="page == 'unregistered_services_reports'" @mtdBack="mtdBack" />
        <AsistenciaReportRankVue class="pt-1" v-if="page == 'asistencia_reports_rank'" @mtdBack="mtdBack" />
        <CrmClientVue class="pt-1" v-if="page == 'crm_clients_quotes'" @mtdBack="mtdBack" />
        <ListCrmClientVue class="pt-1" v-if="page == 'list_crm_clients_quotes'" @mtdBack="mtdBack" />
        <UtilitiesReportVue class="pt-1" v-if="page == 'utilities'" @mtdBack="mtdBack" />
        <PaymentReportVue class="pt-1" v-if="page == 'payment_report'" @mtdBack="mtdBack" />
      </CCol>
    </CRow>
  </div>
</template>

<script>

import ReportsVue from '../../components/reports/Home.vue';
import PurchaseVue from '../../components/reports/ReportPurchase.vue';
import SaleVue from '../../components/reports/ReportSale.vue';
import citasVue from '../../components/reports/ReportQuote.vue';
import AsistenciaReportVue from '../../components/reports/ReportAsistencia.vue';
import AsistenciaReportKatalynasVue from '../../components/reports/Katalynas/ReportAsistencia.vue';
import EncargadoReportVue from '../../components/reports/ReportEncargado.vue';
import CajaReportVue from '../../components/reports/ReportCaja.vue';
import ClientReportVue from '../../components/reports/ReportClient.vue';
import ReportDocument from '../../components/reports/ReportDocument.vue';
import ReportUnregisteredServicesVue from '../../components/reports/ReportUnregisteredServices.vue';
import AsistenciaReportRankVue from '../../components/reports/ReportAsistenciaRank.vue';
import CrmClientVue from '../../components/reports/CrmClients.vue';
import ListCrmClientVue from '../../components/reports/ClientsList.vue';
import UtilitiesReportVue from '../../components/reports/UtilitiesReport.vue';
import PaymentReportVue from '../../components/reports/Katalynas/ReportPayment.vue';

import EncargadoReportVueKatalynas from '../../components/reports/Katalynas/ReportEncargado.vue';


export default {
  components: {
    ReportsVue,
    PurchaseVue,
    SaleVue,
    citasVue,
    EncargadoReportVue,
    CajaReportVue,
    ClientReportVue,
    ReportDocument,
    ReportUnregisteredServicesVue,
    AsistenciaReportRankVue,
    CrmClientVue,
    ListCrmClientVue,
    EncargadoReportVueKatalynas,
    UtilitiesReportVue,
    AsistenciaReportVue,
    AsistenciaReportKatalynasVue,
    PaymentReportVue
  },
  data() {
    return {
      page: 'home',
    }
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.$emit("mtdViewFooter", false, 'home');
    },
    returnHome() {
      this.page = 'home';
      this.$emit("mtdViewFooter", true, 'home');
    },
    hasRoles(roles) {
      return roles.some(role => this.userRoles.includes(role));
    },
    mtdBack: function () {
      this.page = 'home';
      // this.$emit('setView', 'home')
    },
    setView: function () {
      this.$emit('setView', 'home')
    }
  }
};
</script>